const API_ADMIN = process.env.VUE_APP_API_ADMIN_LOCATION;

export default {
  fetchB2BAssessmentPackage(language) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`${API_ADMIN}b2b-assessment-packages`, {
          headers: {
            'Accept-Language': language,
            ignoreLoading: true,
          },
        })
        .then(({ data }) => {
          resolve(data.data || []);
        })
        .catch(reject);
    });
  },

  createB2BAssessmentPackage(payload) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`${API_ADMIN}b2b-assessment-packages`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },

  updateB2BAssessmentPackage(id, payload) {
    return new Promise((resolve, reject) => {
      window.axios
        .patch(`${API_ADMIN}b2b-assessment-packages/${id}`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },

  deleteB2BAssessmentPackage(id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`${API_ADMIN}b2b-assessment-packages/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
};
